module.exports = __webpack_public_path__ + "img/76.10.pH.4ba258ea.png";